import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import classnames from 'classnames';
import ResultsGroup from './ResultsGroup';
import Counter from './Counter';
import Sorting from './Sorting';
import {tabletMediaQuery} from 'helpers/mediaQuery';

class Results extends Component {
  state = {
    isTablet: tabletMediaQuery.matches,
    percentageLoading: 0,
    resultsTotalCounts: 0,
    interval: null
  };

  static getDerivedStateFromProps({resultsCounts, loading}, {resultsTotalCounts, percentageLoading}) {
    if (resultsCounts > resultsTotalCounts && percentageLoading < 91 && loading) {
      return {
        percentageLoading: percentageLoading + 15,
        resultsTotalCounts
      };
    }
    return null;
  }

  componentDidMount() {
    this.updateLoading(this.props.resultsCounts.total);
    const interval = setInterval(() => {
      if (this.state.percentageLoading < 91 && this.props.loading) {
        this.setState({percentageLoading: this.state.percentageLoading + 1});
      } else {
        this.setState({percentageLoading: 100});
        clearInterval(this.state.interval);
      }
    }, 1000);
    this.setState({interval});
    tabletMediaQuery.addEventListener('change', ({matches}) => this.setState({isTablet: matches}));
  }

  updateLoading = (resultsTotalCounts) => {
    if (resultsTotalCounts > this.state.resultsTotalCounts && this.state.percentageLoading < 91 && this.props.loading) {
      this.setState({
        percentageLoading: this.state.percentageLoading + 15,
        resultsTotalCounts
      });
    }
  };

  render() {
    const {isTablet} = this.state;
    const {
      results, searchQuery, loading, sorting, setSortingType,
      resultsCounts: {total, remaining}, translations
    } = this.props;

    const {resultsTitle} = translations;
    const progressLoaderStyle = classnames({
      'progress': true,
      'hide': !loading
    });

    return (
      <>
        <div className="d-flex align-items-center">
          <Counter
            resultsTitle={resultsTitle}
            remain={remaining}
            total={total}
            sidebar={false}
            loading={loading}
          />
          <Sorting
            sorting={sorting}
            setSortingType={setSortingType}
            translations={translations}
          />
        </div>
        <div className={progressLoaderStyle}>
          <div className="progress-bar" style={{'width': `${this.state.percentageLoading}%`}}/>
        </div>
        <ResultsGroup
          total={total}
          remaining={remaining}
          loading={loading}
          results={results}
          searchQuery={searchQuery}
          isTablet={isTablet}
          translations={translations}
        />
      </>
    );
  }
}

Results.propTypes = {
  results: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  resultsCounts: PropTypes.shape({
    total: PropTypes.number,
    remaining: PropTypes.number
  }).isRequired,
  sorting: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
    selected: PropTypes.bool
  }).isRequired,
  searchQuery: PropTypes.object.isRequired,
  setSortingType: PropTypes.func.isRequired,
  translations: PropTypes.object.isRequired
};

export default observer(Results);
